import { useQuery } from '@tanstack/react-query';
import { Button, Container, Nav, Navbar, Spinner } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import { fetchAuthStatus, logout } from '../api/authApi';

export function ClientPortalLayout({ children }) {
  const { data: authData, isLoading } = useQuery({
    queryKey: ['auth-status'],
    queryFn: fetchAuthStatus,
  });

  const username = authData?.user?.username || 'Guest';

  return (
    <div className="client-portal-layout">
      <Navbar expand="lg" bg="body-tertiary" className="border-bottom">
        <Container fluid>
          <Navbar.Brand as={Link} to="/client">
            Nordecon Customer Portal
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="client-portal-nav" />
          <Navbar.Collapse id="client-portal-nav">
            <Nav className="me-auto">
              <Nav.Link as={NavLink} end to="/client">Home</Nav.Link>
              <Nav.Link as={NavLink} to="/client/orders">All orders</Nav.Link>
              <Nav.Link as={NavLink} to="/client/deliveries">All deliveries</Nav.Link>
              <Nav.Link as={NavLink} to="/client/invoices">All invoices</Nav.Link>
            </Nav>
            <Navbar.Text className="me-4 py-0 text-center">
              {isLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <>
                  <div>Logged in as <strong>{username}</strong></div>
                </>
              )}
            </Navbar.Text>
            <Button variant="outline-success" onClick={() => logout()}>
              Log out
            </Button>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {children}
    </div>
  );
}
